import { useQuery } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { ICTABanner } from "./../../models/ctaBanner/CTABanner";
import { ctaBannersQueryKeys } from "./queryKeys";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";

export function useCTABanners(agencyId: string) {
  const { get } = useApiHelper();

  const ctaBanners = useQuery({
    queryKey: ctaBannersQueryKeys.all(agencyId),
    queryFn: () =>
      get(
        `/marketing/${agencyId}/ctabanner`
      ) as unknown as IDefaultResponseWithData<ICTABanner[]>,
    refetchOnWindowFocus: false,
  });

  return {
    ctaBanners,
  };
}
